import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {adminRoutes, newString} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import {useParams} from "react-router-dom";
import useGet from "../../components/hooks/useGet";
import moment from "moment/moment";
import {defaultDateTimeFormat} from "../../utils/date";
import {Alert, Button } from "fearless-common-ui";
import Loading from "../../components/Loading";
import FloatingLabelField from "../../components/forms/FloatingLabelField";
import {BackendForm} from "../../components/forms";
import AdminNotes from "../../components/admin/AdminNotes";
import {concepts, Institute} from "fearless-common";
import useTitle from "../../components/hooks/useTitle";
import {backendEndpoints} from "../../libs/backendEndpoints";

function InnerAdminInstitute({ institute, isNew }: { institute?: Institute; isNew: boolean }) {
    useTitle(isNew ? `New ${concepts.Institute}` : `Admin ${concepts.Institute}: ${institute?.name}`);
    return (
        <Row>
            <Col>
                <BackendForm<Omit<Institute, 'id' | 'created_at' | 'updated_at'>, { id: number }>
                    initialValues={institute || {
                        name: '',
                    }}
                    targetEndpoint={!institute ? backendEndpoints.createAdminInstitute : backendEndpoints.getAdminInstitute(institute.id)}
                    targetMethod={isNew ? 'POST' : 'PUT'}
                    onSuccess={({ data}) => {
                      window.location.href = data?.id ? adminRoutes.institute(data.id) : adminRoutes.institutes;
                    }}
                >
                    <FloatingLabelField name="name" label="Name"/>
                </BackendForm>
            </Col>
            <Col>
                {!isNew && institute ? (
                    <AdminNotes type="App\Models\Institute" typeId={institute.id} />
                ) : null}
            </Col>
        </Row>
    );
}

/**
 * Show a form to edit an institute
 */
export default function AdminInstitute() {
    const { instituteId } = useParams();
    const isNew = instituteId === newString;
    const {
        data: institute,
        error,
        isLoading,
    } = useGet<Institute>({
        endpoint: isNew ? '' : `/admin/institutes/${instituteId}`,
    });

    return (
        <Pages.Centred>
            <Button variant="primary" icon="fa fa-arrow-left" className="mb-2" href={adminRoutes.institutes}>
              Back to {concepts.Institutes}
            </Button>
            <h1>{isNew ? `New ${concepts.Institute}`: `${concepts.Institute}: ${institute?.name}`}</h1>
            <div className="d-flex gap-4 mb-3">
                <span>Created at: {moment(institute?.created_at).format(defaultDateTimeFormat)}</span>
                <span>Last updated: {moment(institute?.updated_at).format(defaultDateTimeFormat)}</span>
            </div>
            {error && <Alert>{error}</Alert>}
            {isLoading && <Loading />}
            {(institute || isNew) && (
                <InnerAdminInstitute institute={institute} isNew={isNew} />
            )}
        </Pages.Centred>
    );
}
